import appConfig from 'appConfig';
import TreeContrast from '../treeContrast/treeContrast.vue'; //树控件
export default {
  name: 'rollerContrast',
  data() {
    return {
      split2: 0.5,
      baseMapLayer: "",
      baseMapImgLayer: "",
      baseMapFontLayer: "",
      mapr: {},
      rightLayers: [],
      treeC1: false,
      treeC2: false,
      projection: this.$olmap.proj.get(appConfig.map.proj),
      zindex:100
    };

  },
  components: {
    TreeContrast
  },
  computed: {},
  props: {
  },
  watch: {
  },
  mounted() {
    if (appConfig.map.isProj) {
      this.projection = new this.$olmap.proj.Projection({ 
        code: appConfig.map.proj, 
        units: this.$olmap.proj.Units.METERS, 
        extent: extent 
      });
    }
    this.initMap()
  },
  created() {
    this.configMap = appConfig.map;
  },
  methods: {
    initMap() {
      // 特殊空间参考注册
			var extent = [-180,-90,180,90]
			proj4.defs(appConfig.map.proj, appConfig.map.defsCode);
			//投影坐标系
			var projection = new this.$olmap.proj.Projection({ code: appConfig.map.proj, units: this.$olmap.proj.Units.METERS, extent: extent });
			//中心点
			var center = this.$olmap.extent.getCenter(extent);
      var resolutions = appConfig.map.resolutions.reso;
      this.mapr = new this.$olmap.Map({
        logo: false,
        target: 'rollerMap',
        layers: [],
        controls: this.$olmap.control.defaults({
          attribution: false,
          rotate: false,
          zoom: false,
        }),
        view: new this.$olmap.View({
          center: [appConfig.map.center.lng, appConfig.map.center.lat],
          zoom: appConfig.map.zoom,
          projection: projection,
        }),
      });
      this.addBaseMap(resolutions);
      if (appConfig.baseLayersConfig.vectorMap) {
        // 矢量底图
        var type = appConfig.baseLayersConfig.vectorMap.type;
        this.zindex ++
        switch (type) {
          case "layer.ImageArcGISRest":
            this.baseMapLayer = this.publicMethod.getImageArcGISRest(appConfig.baseLayersConfig.vectorMap ,this.zindex , this.$olmap);
            break;
          case "layer.TileArcGISRestXYZ":
            this.baseMapLayer = this.publicMethod.getArcgisXYZTile(appConfig.baseLayersConfig.vectorMap,appConfig.map.origin, resolutions ,this.zindex,
              this.$olmap , this.projection , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax]);
            break;
          case "layer.TileArcGISRest":
            this.baseMapLayer = this.publicMethod.getTileArcGISRestLayer(appConfig.baseLayersConfig.vectorMap , appConfig.map.origin , resolutions , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax],
              this.projection , this.$olmap);
            break;
          case "layer.TileArcGISRestTD":
            this.baseMapLayer = this.publicMethod.getArcgisXYZTileTD(appConfig.baseLayersConfig.vectorMap, this.zindex ,  this.$olmap);
            break;
          default:
            break;
        }
        this.mapr.addLayer(this.baseMapLayer)
      }
      this.initSwipeDom(this.mapr);
      this.rollerRightLayer(this.baseMapLayer);
    },


    initSwipeDom(map) {
      var swipe = document.getElementById("swipeContainer");
      var obj = {};
      swipe.onmousedown = function (event) {
        var e = event || window.event;
        // 鼠标点击元素那一刻相对于元素左侧边框的距离=点击时的位置相对于浏览器最左边的距离-物体左边框相对于浏览器最左边的距离
        obj.diffX = e.clientX - this.offsetLeft;
        document.onmousemove = function (event) {
          var e = event || window.event;
          var moveX = e.clientX - obj.diffX;
          if (moveX < 0) {
            moveX = 0
          } else if (moveX > window.innerWidth - swipe.offsetWidth) {
            moveX = window.innerWidth - swipe.offsetWidth
          }
          swipe.style.left = moveX + 'px';

          //重新渲染图层
          map.render();
        };
        document.onmouseup = function () {
          this.onmousemove = null;
          this.onmouseup = null;
        }
      };
    },

    swipeLayer(map) {
      var layers = map.getLayers();
      var topLayer = layers.item(layers.getLength() - 1);
      this.rightLayers.push(topLayer);
      topLayer.on('precompose', function (event) {
        var swipe = document.getElementById("swipeContainer");
        var ctx = event.context;
        //计算图层在canvas画布上需要显示的范围
        var mapSize = map.getSize();
        var height = event.context.canvas.height;
        var width = event.context.canvas.width;
        var swipeWidth = swipe.offsetLeft * width / mapSize[0];
        var tl = [swipeWidth, 0];
        var tr = [width, 0];
        var bl = [swipeWidth, height];
        var br = [width, height];

        ctx.save();
        //绘制裁剪路径
        ctx.beginPath();
        ctx.moveTo(tl[0], tl[1]);
        ctx.lineTo(bl[0], bl[1]);
        ctx.lineTo(br[0], br[1]);
        ctx.lineTo(tr[0], tr[1]);
        ctx.closePath();
        //裁剪，裁剪路径以外的部分不会绘制在canvas上下文中
        ctx.clip();
      });
      topLayer.on('postcompose', function (event) {
        var ctx = event.context;
        ctx.restore();
      });
    },

    rollerLeftLayer(Layer) {
      var that = this;
      this.rightLayers.forEach(element => {    //1.先移除所有右边的
        that.mapr.removeLayer(element);
      });
      this.mapr.addLayer(Layer);    //2.再添加当前左边的
      this.rightLayers.forEach(rLayer => {   //2.恢复右边图层
        that.mapr.addLayer(rLayer);
      });
    },

    removeRightLayer(layer) {
      var id = layer.getProperties().id;
      var newArr = this.rightLayers.filter(function (list) {
        return id !== list.getProperties().id;
      });
      this.rightLayers = newArr;
    },

    rollerRightLayer(layer) {
      var lays = {};
      lays[layer.getProperties().id] = layer
      this.rightLayers.push(layer);
      var mapSize = this.mapr.getSize();
      //请求bing地图数据前，根据滑块值设置渲染范围
      layer.on('precompose', function (event) {
        var swipe = document.getElementById("swipeContainer");
        var ctx = event.context;
        //计算图层在canvas画布上需要显示的范围
        var height = event.context.canvas.height;
        var width = event.context.canvas.width;
        var swipeWidth = swipe.offsetLeft * width / mapSize[0];
        var tl = [swipeWidth, 0];
        var tr = [width, 0];
        var bl = [swipeWidth, height];
        var br = [width, height];
        ctx.save();
        //绘制裁剪路径
        ctx.beginPath();
        ctx.moveTo(tl[0], tl[1]);
        ctx.lineTo(bl[0], bl[1]);
        ctx.lineTo(br[0], br[1]);
        ctx.lineTo(tr[0], tr[1]);
        ctx.closePath();
        //裁剪，裁剪路径以外的部分不会绘制在canvas上下文中
        ctx.clip();
      });
      //请求完成，渲染
      layer.on('postcompose', function (e) {
        var ctx = e.context;
        ctx.restore();
      });
    },


    addBaseMap(resolutions) {
      if (appConfig.baseLayersConfig.imageMap) {
        // 矢量底图
        var type = appConfig.baseLayersConfig.imageMap.type;
        this.zindex ++
        switch (type) {
          case "layer.ImageArcGISRest":
            this.baseMapImgLayer = this.publicMethod.getImageArcGISRest(appConfig.baseLayersConfig.imageMap , this.zindex , this.$olmap);
            break;
          case "layer.TileArcGISRestXYZ":
            this.baseMapImgLayer = this.publicMethod.getArcgisXYZTile(appConfig.baseLayersConfig.imageMap,appConfig.map.origin, resolutions ,this.zindex,
              this.$olmap , this.projection , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax]);
            break;
          case "layer.TileArcGISRest":
            this.baseMapImgLayer = this.publicMethod.getTileArcGISRestLayer(appConfig.baseLayersConfig.imageMap , appConfig.map.origin , resolutions , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax],
              this.projection , this.$olmap);
            break;
          case "layer.TileArcGISRestTD":
            this.baseMapImgLayer = this.publicMethod.getArcgisXYZTileTD(appConfig.baseLayersConfig.imageMap, this.zindex ,  this.$olmap);
            break;
          default:
            break;
        }
        this.mapr.addLayer(this.baseMapImgLayer)
      }

      if (appConfig.baseLayersConfig.vectorFontMap) {
        // 矢量底图
        var type = appConfig.baseLayersConfig.vectorFontMap.type;
        switch (type) {
          case "layer.TileArcGISRestTD":
            this.baseMapFontLayer = this.publicMethod.getArcgisXYZTileTD(appConfig.baseLayersConfig.vectorFontMap, this.zindex ,  this.$olmap);
            break;
          case "layer.ImageArcGISRest":
            this.baseMapFontLayer = this.publicMethod.getImageArcGISRest(appConfig.baseLayersConfig.vectorFontMap , this.zindex , this.$olmap);
            break;
          case "layer.TileArcGISRestXYZ":
            this.baseMapFontLayer = this.publicMethod.getArcgisXYZTile(appConfig.baseLayersConfig.vectorFontMap,appConfig.map.origin, resolutions ,this.zindex,
              this.$olmap , this.projection , [appConfig.map.extent.XMin, appConfig.map.extent.YMin, appConfig.map.extent.XMax, appConfig.map.extent.YMax]);
            break;
          default:
            break;
        }
        this.mapr.addLayer(this.baseMapFontLayer)
      }
    },
    changeTree(index, type) {
      this["treeC" + index] = type;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/contrastComponent/rollerContrast/rollerContrast.js